<template>
    <AccessLayoutComponent :form-title="formTitle">
        <template v-slot:form>
            <SignInFormComponent @set-form-title="formTitle = $event" />
        </template>
    </AccessLayoutComponent>
</template>

<script>
import AccessLayoutComponent from "@Layouts/access";
import {
    SignInFormComponent,
} from "@AccessModule/components";
import { ref } from 'vue';
export default {
    name: "LoginViewModule",
    components: {
        AccessLayoutComponent,
        SignInFormComponent,
    },
    setup() {
        const formTitle = ref('');
        return { formTitle };
    }
}
</script>

<style>

</style>